import Axios from 'axios';
import type { TemplateUsage } from '@bb/domain/dist/types';
import type { JsonObject, TemplateListAllResponse } from '@/app-package';

type TemplateListAllResponseJson = JsonObject<TemplateListAllResponse>;

const getTemplates = async (listingId: string, type: TemplateUsage) => {
  const { data } = await Axios.get<TemplateListAllResponseJson>(
    `/listing/${listingId}/template/list?type=${type}`,
  );
  return data;
};

type Template = TemplateListAllResponseJson[number];

export { getTemplates, Template };
